import { render, staticRenderFns } from "./PhEnvelope.vue?vue&type=template&id=ae16a2d4"
import script from "./PhEnvelope.vue?vue&type=script&lang=js"
export * from "./PhEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports